<% if (Anvil.page.modal.issue.link == 'terminal' || Anvil.page.modal.issue.link == 'aee') { %>
<%- include('/ui/form', {
	params: [ 'issue_link_terminal', Anvil.page.modal.issue ],
	fields: [
		{
			type: 'select',
			name: 'terminal_id',
			title: 'Terminál',
			params: {
				maxItems: 1,
				options: Anvil.page.modal.terminals.data.filter(x => x.company_id == Anvil.page.modal.issue.company_id && x.company_db_id == Anvil.page.modal.issue.company_db_id && x.site_id == Anvil.page.modal.issue.site_id),
				valueField: 'machine_id',
				labelField: 'name',
				searchField: [ 'name' ],
				render: {
					item: (item, esc) => `<div>${esc(item.device_info.hostname)}<br /><small>${esc(item.default_cashreg_ap)}</small></div>`,
					option: (item, esc) => `<div class="option">${esc(item.device_info.hostname)}<br /><small>${esc(item.default_cashreg_ap)}</small></div>`
				}
			},
			unset_value: null,
			attributes: Anvil.page.modal.issue.closed ? { disabled: 'disabled' } : null,
			update: (value) => {

				// Reset values
				Anvil.page.modal.issue.aee_id = null

				// Re-render aee picker
				Anvil.render('/issue/modal_edit_panel_link_aee', {}, '#panel-link-aee')
			}
		}
	]
}) %>
<% } %>